/* eslint-disable func-style */
import * as React from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { useTranslations } from "next-intl";
import { useWindowDimensions } from "@quales/utils/hooks";
import { useTheme } from "@quales/utils/theme";

/* eslint-disable-next-line */
interface customModalProps {
  modalTitle: string;
  openModal: boolean;
  closeHandler: (event?: any, reason?: string) => void;
  children: React.ReactNode;
  minWidth?: number | string;
  disableEscapeKey?: boolean;
  editEnabled?: boolean;
}

export function CustomModal(props: customModalProps) {
  const {
    openModal,
    closeHandler,
    modalTitle,
    minWidth,
    editEnabled,
    disableEscapeKey,
    children,
  } = props;
  const t = useTranslations();
  const handleClose = (event: any, reason: string) => {
    closeHandler(event, reason);
  };
  const { height } = useWindowDimensions();
  const theme = useTheme();
  const style = {
    position: "absolute" as "absolute",
    top: "40px",
    left: "50%",
    transform: "translate(-50%, 0)",
    bgcolor: theme.appColors.surfaceContainerLow,
    boxShadow: 24,
    borderRadius: 6,
    padding: 6,
  };

  const handleClosePressed = () => {
    closeHandler();
  };
  return (
    <Modal
      open={openModal}
      disableEscapeKeyDown={disableEscapeKey}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        id="CustomModal"
        sx={style}
        minWidth={minWidth ? minWidth : "inherit"}
      >
        <Stack width="100%" direction="row" padding={2}>
          <Stack width="100%" direction="row">
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h4"
              width={"100%"}
            >
              {modalTitle}
            </Typography>
            {editEnabled && (
              <Typography
                variant="body1"
                component="h4"
                alignSelf="center"
                ml={2}
                color={theme.appColors.error}
              >
                {t("labels.editMode")}
              </Typography>
            )}

            <Stack width="30%" direction="row-reverse" alignItems="center">
              <IconButton
                onClick={handleClosePressed}
                sx={{
                  display: "flex",
                  width: "19px",
                  height: "19px",
                }}
              >
                <CloseIcon sx={{ color: "action.active", fontSize: 18.67 }} />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
        <Divider />
        <Stack
          id="CustomModalInnerStack"
          width="100%"
          maxHeight={height ? height - 140 : "100%"}
          padding={2}
          alignItems="center"
          overflow={"hidden"}
        >
          {children}
        </Stack>
      </Box>
    </Modal>
  );
}

export default CustomModal;
